import { getStaticPathsForLocales } from '../../../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { FullAmendAvailabilityPage } from '../../../../../features/parking/ui/booking-pages/full-amend/FullAmendAvailabilityPage';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps = () => ({ props: {} });

export default FullAmendAvailabilityPage;
